/* tslint:disable */

declare var Object: any;
export interface ViewOvertimeReportInterface {
  "empId"?: string;
  "fullName"?: string;
  "posNameEn"?: string;
  "ovtdate": Date;
  "rmAfter"?: number;
  "ovthours"?: string;
  "status": number;
  "remark"?: string;
}

export class ViewOvertimeReport implements ViewOvertimeReportInterface {
  "empId": string;
  "fullName": string;
  "posNameEn": string;
  "ovtdate": Date;
  "rmAfter": number;
  "ovthours": string;
  "status": number;
  "remark": string;
  constructor(data?: ViewOvertimeReportInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ViewOvertimeReport`.
   */
  public static getModelName() {
    return "ViewOvertimeReport";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ViewOvertimeReport for dynamic purposes.
  **/
  public static factory(data: ViewOvertimeReportInterface): ViewOvertimeReport{
    return new ViewOvertimeReport(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ViewOvertimeReport',
      plural: 'ViewOvertimeReports',
      path: 'ViewOvertimeReports',
      properties: {
        "empId": {
          name: 'empId',
          type: 'string'
        },
        "fullName": {
          name: 'fullName',
          type: 'string'
        },
        "posNameEn": {
          name: 'posNameEn',
          type: 'string'
        },
        "ovtdate": {
          name: 'ovtdate',
          type: 'Date'
        },
        "rmAfter": {
          name: 'rmAfter',
          type: 'number'
        },
        "ovthours": {
          name: 'ovthours',
          type: 'string'
        },
        "status": {
          name: 'status',
          type: 'number'
        },
        "remark": {
          name: 'remark',
          type: 'string'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ViewOvertimeReport.ts